/*
/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2023-01-06 11:28:38
 * @LastEditors: Yj
 * @LastEditTime: 2023-08-03 15:39:14
 * @FilePath: \qcloud-web-pc-4.0\src\api\config.ts
 * @Description: api前缀配置
 */

export const apiPrefix = 'api'

// 费用中心
export const feePrefix = 'fee'

export const regPrefix = 'reg'; // 访问管理服务

export const regInstance = 'instanceCenter'